'use client';

import type { ThemeVariables } from '@/themes/mpanels/variables';
import type { Theme } from '@mui/material';
import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';
import { devtools } from 'zustand/middleware';
import { config } from '@/config';
import { Environment } from '@/types/enums/environment';

const applyDevtools = (config.nodeEnv === Environment.Production
    ? (fn: unknown) => fn
    : devtools) as unknown as typeof devtools;

interface ThemeStore {
    theme: Theme;
    variables: ThemeVariables;
    setTheme: (theme: Theme) => void;
    setVariables: (variables: ThemeVariables) => void;
}

export const useThemeStore = createWithEqualityFn<ThemeStore>()(
    applyDevtools(
        (set) => ({
            // casting these as they will be set in the app.tsx file
            theme: null as unknown as Theme,
            variables: null as unknown as ThemeVariables,
            setTheme: (theme) => set({ theme }),
            setVariables: (variables) => set({ variables }),
        }),
        { name: `MPW ${config.theme} Theme Store` },
    ),
    shallow,
);
